export default {"src":"/_next/static/media/0x12BB890508c125661E03b09EC06E404bc9289040.a4afeb89.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};